import { render, staticRenderFns } from "./AllNotifications.vue?vue&type=template&id=7b5e9f8a&scoped=true"
import script from "./AllNotifications.vue?vue&type=script&lang=js"
export * from "./AllNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5e9f8a",
  null
  
)

export default component.exports